import { forwardRef } from "react";

const EditableTitle = forwardRef((props, ref) => {
  const { isLoaded } = props;

  if (!isLoaded) {
    return (
      <div className="mb-10">

      </div>
    );
  } else {
    return (
      <div className="mb-10">
        {/* <label
          htmlFor={props.name}
          className="block mb-2 text-lg font-semibold text-text"
        >
          {props.title}
        </label> */}
        <input
            type={props.type}
            autoComplete={props.autocomplete}
            className="block mb-2 text-lg font-semibold text-text border-none focus:outline-none w-full"
            id={props.name}
            name={props.name}
            ref={ref}
            value={props.value}
            onChange={props.onChange}
            onBlur={props.onBlur}
            placeholder={props.placeholder}
        />
      </div>
    );
  }

  });
  
  export default EditableTitle;